import React from "react";
import { AutoFixHigh as Wand2, AddPhotoAlternate as ImagePlus } from "@mui/icons-material";
import styles from "./ModeToggle.module.css";

function ModeToggle({ mode, onEnhance, onGenerate }) {
  return (
    <div className={styles.toggle}>
      <button
        type="button"
        onClick={onEnhance}
        className={`${styles.btn} ${mode === "enhance" ? styles.btnActive : ""}`}
      >
        <Wand2 sx={{ fontSize: 16 }} />
        Enhance image
      </button>
      <button
        type="button"
        onClick={onGenerate}
        className={`${styles.btn} ${mode === "generate" ? styles.btnActive : ""}`}
      >
        <ImagePlus sx={{ fontSize: 16 }} />
        Image generation
      </button>
    </div>
  );
}

export default React.memo(ModeToggle);
